import styled from '@emotion/styled';
import { Link, tokens } from '@hotjar/hotsauce';
import type { ProductCatalog } from '@hotjar/webapp/domains/common/product/types';
import type { MultiSkuDropdownProps } from '../MultiSkuDropdown/MultiSkuDropdown';
import { MultiSkuDropdown } from '../MultiSkuDropdown/MultiSkuDropdown';

const productTypesByComparisonLink: Record<keyof ProductCatalog, string> = {
  analyticsProducts: 'https://www.hotjar.com/pricing',
  feedbackProducts: 'https://www.hotjar.com/pricing',
};

const S = {
  SelectAndComparisonLinksContainer: styled.div`
    display: flex;
    max-width: 560px;
    & > * {
      flex: 1;
    }
  `,
  ComparisonLinksContainer: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-end;
    gap: ${tokens.spacer.x2};
  `,
  Link: styled(Link)`
    flex: 1;
    display: flex;
    align-items: center;
    margin: ${tokens.spacer.x3} 0 0 ${tokens.spacer.x3};
  `,
};

export const MultiSkuComparisonLinks = (props: MultiSkuDropdownProps): JSX.Element => {
  return (
    <S.SelectAndComparisonLinksContainer>
      <MultiSkuDropdown {...props} />
      <S.ComparisonLinksContainer>
        {Object.entries(productTypesByComparisonLink).map(([productType, link]) => (
          <S.Link
            key={productType}
            href={link}
            kind="standalone"
            isExternal
            data-testid={`comparison-link-${productType}`}
          >
            Learn more about product and plans
          </S.Link>
        ))}
      </S.ComparisonLinksContainer>
    </S.SelectAndComparisonLinksContainer>
  );
};
